import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Col, Form, Input, Radio, Row, Typography } from "antd";
import moment from "moment/moment";
import { doVerifyEmail } from "stores/slices/auth";

import AppButton from "components/button";
import SelectMultiple from "components/inputs/selectSearchSingle";

import ModalForm from "../../../components/forms/components/modalForm";
import { USER_TYPE, WORKSPACE_USER_TYPE } from "../../../constants/appConstant";
import {
  doGetSubscriptionDetail,
  doGetUseSubscription,
  getCurrentSubscription,
} from "../../../stores/slices/subscriptions";
import { numOfEls } from "../../../stores/slices/user";
import {
  doGetWorkspacePage,
  WorkspaceInfo,
} from "../../../stores/slices/workspace";
import { doCreateWorkspaceUser } from "../../../stores/slices/workspaceUser";

import styles from "../../../components/styles.module.scss";

const UserAddForm = props => {
  const {
    workspaceId,
    setLoadingList,
    loadingList,
    workspaceName,
    isViewFrm,
    userType,
    onCancel,
    onSuccess,
  } = props;
  const formRef = React.useRef(null);

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isView, setIsView] = useState(true);
  const [isShowConfirmPopup, setIsShowConfirmPopup] = useState(false);
  const noOfElements = useSelector(numOfEls);

  const workspaceDetail = useSelector(WorkspaceInfo);
  const currentSubscription = useSelector(getCurrentSubscription);
  const [subscriptionPackage, setSubscriptionPackage] = useState({});
  const [objectPrice, setObjectPrice] = useState({});

  const dispatch = useDispatch();

  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [workspacecQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
    sortFieldWorkspace: "createdTime",
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [isSkip, setIsSkip] = useState(false);
  useEffect(() => {
    if (userType === USER_TYPE.SUPER_ADMIN) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  }, []);

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    if (request.isReset) {
      setOptionWorkspace([]);
      setListAllWorkspace([]);
      delete newRequest.isReset;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllWorkspace(removeDuplicates([...payload.content]));
      } else {
        setListAllWorkspace(
          removeDuplicates([...listAllWorkspace, ...payload.content])
        );
      }
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          key: item.id,
          label: item.name,
        };
      });
      setOptionWorkspace(newOptions);
    } else {
      setOptionWorkspace([]);
    }
  }, [listAllWorkspace]);

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspacecQueries.pageNumber <= totalWorkspacePages &&
      !loadingList
    ) {
      fetchListWorkspace({
        ...workspacecQueries,
        pageNumber: workspacecQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const handleSearchKeyWorkspace = key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const onFinish = async () => {
    const isOverSeat = await checkExtraSeat();
    if (isOverSeat) {
      setShowWarningModal(true);
    } else if (objectPrice.overSeat > 0 && userType === USER_TYPE.USER) {
      setIsShowConfirmPopup(true);
    } else {
      await doCheckout();
    }
  };

  const checkExtraSeat = async () => {
    let overSeat = false;
    if (
      currentSubscription?.downgrade &&
      currentSubscription?.downgradePackageId
    ) {
      const { payload } = await dispatch(
        doGetSubscriptionDetail(currentSubscription.downgradePackageId)
      );
      if (
        payload &&
        payload?.perSeatInc &&
        ((payload?.perSeatInc < subscriptionPackage?.perSeatInc &&
          payload?.perSeatInc < currentSubscription?.currentNumberOfUser + 1) ||
          (payload?.perSeatInc === subscriptionPackage?.perSeatInc &&
            noOfElements + 1 > subscriptionPackage?.perSeatInc))
      ) {
        overSeat = true;
        if (
          payload?.perSeatInc < subscriptionPackage?.perSeatInc &&
          payload?.perSeatInc < currentSubscription?.currentNumberOfUser + 1
        ) {
          setIsSkip(true);
        } else {
          setIsSkip(false);
        }
      }
    }
    return overSeat;
  };

  const doCheckout = async () => {
    const fieldsValue = formRef.current.getFieldsValue();
    setLoading(true);
    const { payload } = await dispatch(
      doVerifyEmail({ email: fieldsValue["email"]?.trim() })
    );
    if (payload && payload.status === 200 && payload.data) {
      doHandleCreateWorkspaceUser(workspaceId, fieldsValue);
    } else {
      toast.error(t("validate.email.invalid"));
      setLoading(false);
      setIsShowConfirmPopup(false);
    }
  };

  const doHandleCreateWorkspaceUser = async (workspaceId, fieldsValue) => {
    const params = {
      workspaceId: workspaceId,
      type: fieldsValue["userType"],
      email: fieldsValue["email"]?.trim(),
    };
    if (workspaceId === "all") {
      params.workspaceId = fieldsValue["workspace"];
    }

    const { payload } = await dispatch(doCreateWorkspaceUser(params));
    if (payload && payload.status === 200) {
      setLoading(false);
      onSuccess();
    } else {
      setLoading(false);
    }
  };

  const loadSubscriptionDetail = async () => {
    const { payload } = await dispatch(
      doGetSubscriptionDetail(currentSubscription.subscriptionPackageId)
    );
    if (payload) {
      setSubscriptionPackage(payload);
    }
  };

  const calculateTotalPrice = () => {
    const now = moment().utc();
    const startDate = moment(currentSubscription?.startTime).utc();
    const endDate = moment(currentSubscription?.endTime).utc();

    const currentTotalDays = moment(endDate).diff(moment(startDate), "days");
    let remainingDays = moment(endDate).diff(moment(now), "days");
    if (now.startOf("date").diff(startDate.startOf("date")) === 0) {
      remainingDays = currentTotalDays;
    }

    let overSeat = noOfElements + 1 > subscriptionPackage?.perSeatInc ? 1 : 0;
    overSeat = overSeat > 0 ? overSeat : 0;

    const costSeatPerUnit =
      currentTotalDays !== remainingDays
        ? subscriptionPackage?.perSeatFee / currentTotalDays
        : subscriptionPackage?.perSeatFee;
    const costSeatTotal =
      currentTotalDays === remainingDays
        ? costSeatPerUnit * overSeat
        : costSeatPerUnit?.toFixed(2) * overSeat * remainingDays;

    const gst = costSeatTotal !== 0 ? costSeatTotal?.toFixed(2) * 0.1 : 0;

    setObjectPrice({
      currentTotalDays: currentTotalDays,
      remainingDays: remainingDays,
      overSeat: overSeat,
      costSeatPerUnit: costSeatPerUnit,
      costSeatTotal: costSeatTotal,
      totalFee: costSeatTotal + gst,
      gst: gst,
    });
    return true;
  };

  useEffect(() => {
    if (userType === USER_TYPE.USER) {
      dispatch(doGetUseSubscription());
    }
  }, []);

  useEffect(() => {
    if (currentSubscription.subscriptionPackageId) {
      loadSubscriptionDetail();
    }
  }, [currentSubscription]);

  useEffect(() => {
    if (subscriptionPackage && noOfElements) {
      calculateTotalPrice();
    }
  }, [subscriptionPackage, noOfElements]);

  const validateMessages = {
    required: t("validate.required"),
    types: {
      email: t("validate.email.invalid"),
    },
  };

  const initValue = () => {
    if (workspaceName) {
      return {
        userType: WORKSPACE_USER_TYPE.ADMIN,
        workspace: workspaceName,
      };
    } else {
      return {
        userType: WORKSPACE_USER_TYPE.ADMIN,
      };
    }
  };

  useEffect(() => {
    setIsView(isViewFrm);
  }, [isViewFrm]);

  const handleTitleWarning = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("payment.warning")}
        </span>
      </div>
    );
  };
  return (
    <div style={{ height: "100%" }}>
      <Form
        ref={formRef}
        initialValues={initValue()}
        layout={"vertical"}
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={validateMessages}
      >
        <p className={styles.required} style={frmStyle.labelTitle}>
          {t("user.workspace")}
        </p>
        <Form.Item name="workspace" rules={[{ required: true }]}>
          {workspaceId === "all" ? (
            <SelectMultiple
              type={"select-search"}
              disabled={isView}
              loading={loadingList}
              showSearch
              allowClear={false}
              optionFilterProp="children"
              options={workspaceOption}
              onChange={value => {
                formRef.current.setFieldsValue({
                  workspaceId: value,
                });
              }}
              config={{
                width: "100%",
              }}
              handleSearch={handleSearchKeyWorkspace}
              handleScroll={handleScrollWorkspace}
            />
          ) : (
            <Input disabled />
          )}
        </Form.Item>

        <p style={frmStyle.labelTitle}>{t("user.userType")}</p>
        <Form.Item name="userType">
          <Radio.Group disabled={isView}>
            <Radio value="ADMIN" style={frmStyle.lineHeightLg}>
              {t("role.admin")}
            </Radio>
            <Radio value="OPERATOR" style={frmStyle.lineHeightLg}>
              {t("role.operator")}
            </Radio>
          </Radio.Group>
        </Form.Item>

        <p className={styles.required} style={frmStyle.labelTitle}>
          {t("user.email")}
        </p>
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              type: "email",
            },
          ]}
        >
          <Input
            disabled={isView}
            maxLength={255}
            placeholder={t("user.email")}
          />
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "16px",
          }}
        >
          {isView && (
            <AppButton
              label={t("button.edit")}
              color={"blue"}
              loading={loading}
              type="primary"
              htmlType="button"
              onClick={() => {
                setIsView(false);
              }}
            />
          )}
          <AppButton
            label={t("button.cancel")}
            color={"grey"}
            loading={loading}
            htmlType="button"
            onClick={() => {
              onCancel();
            }}
          />
          {!isView && (
            <AppButton
              label={t("button.invite")}
              color={"blue"}
              loading={loading}
              type="primary"
              htmlType="submit"
            />
          )}
        </div>
      </Form>

      <ModalForm
        title={t("payment.checkoutExtraSeats")}
        onCancel={() => setIsShowConfirmPopup(false)}
        destroyOnClose={true}
        isOpen={isShowConfirmPopup}
        labelSubmit={t("label.save")}
        customWidth={600}
        footer={false}
        maskClosable={false}
      >
        <Row gutter={[20, 8]}>
          <Col span={12}>{t("payment.noExtraSeats")}</Col>
          <Col span={12} style={frmStyle.textAlignRight}>
            <Typography.Text strong>
              {objectPrice?.overSeat?.toLocaleString()}
            </Typography.Text>
          </Col>
          <Col span={12}>
            {t("payment.price")}
            {objectPrice?.currentTotalDays !== objectPrice?.remainingDays &&
              t("payment.perDay")}
          </Col>
          <Col span={12} style={frmStyle.textAlignRight}>
            <Typography.Text strong>
              {"AUD" +
                objectPrice?.costSeatPerUnit?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
            </Typography.Text>
          </Col>
          <Col span={12}>{t("payment.subtotal")}</Col>
          <Col span={12} style={frmStyle.textAlignRight}>
            <Typography.Text strong>
              {"AUD" +
                objectPrice?.costSeatTotal?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
            </Typography.Text>
          </Col>
          <Col span={12}>{t("payment.gst")}</Col>
          <Col span={12} style={frmStyle.textAlignRight}>
            <Typography.Text strong>
              {"AUD" +
                objectPrice?.gst?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
            </Typography.Text>
          </Col>

          <Col span={12}>{t("payment.subscriptionPackage")}</Col>
          <Col
            span={12}
            style={{ ...frmStyle.textAlignRight, fontWeight: "bold" }}
          >
            {subscriptionPackage.name}
          </Col>
          <Col span={12}>{t("payment.totalCost")}</Col>
          <Col
            span={12}
            style={{ ...frmStyle.textAlignRight, fontWeight: "bold" }}
          >
            {"AUD" +
              objectPrice?.totalFee?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
          </Col>
          <Col span={12}>{t("payment.card")}</Col>
          <Col
            span={12}
            style={{ ...frmStyle.textAlignRight, fontWeight: "bold" }}
          >
            {workspaceDetail.cardHolder}
            {"  "}
            ****{workspaceDetail.stripLast4Digit}
          </Col>
        </Row>
        <div style={{ width: "100%", marginTop: 16 }}>
          <AppButton
            label={
              t("payment.pay") +
              " " +
              "AUD" +
              objectPrice?.totalFee?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })
            }
            style={{ width: "100%" }}
            size="small"
            color={"primary"}
            type="submit"
            loading={loading}
            onClick={doCheckout}
          />
        </div>
      </ModalForm>
      <ModalForm
        title={handleTitleWarning()}
        onCancel={() => setShowWarningModal(false)}
        destroyOnClose={true}
        isOpen={showWarningModal}
        customWidth={600}
        maskClosable={false}
        footer={[
          <AppButton
            key="button-cancel"
            label={t("button.cancel")}
            color={"grey"}
            htmlType="button"
            onClick={() => {
              setShowWarningModal(false);
            }}
          />,
          <AppButton
            key="button-continue"
            label={t("button.continue")}
            color={"blue"}
            htmlType="button"
            onClick={() => {
              setShowWarningModal(false);
              if (isSkip) {
                doCheckout();
              } else {
                setIsShowConfirmPopup(true);
              }
            }}
          />,
        ]}
      >
        {t("payment.warningExtraSeat")}
      </ModalForm>
    </div>
  );
};

const frmStyle = {
  labelTitle: {
    marginBottom: 4,
  },
  lineHeightLg: {
    lineHeight: "1.2rem",
  },
  appearBox: {
    backgroundColor: "#F9FAFB",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "16px",
  },
  textAlignRight: {
    textAlign: "right",
  },
};

export default UserAddForm;
